/**
 * The month a cost page reads. It scopes everything below it, so it sits at
 * the top of the page body as a filter, not in the header beside the export
 * (Feature 70, §6.2: the header holds one action).
 */
export function PeriodPicker({
  value,
  onChange,
}: {
  /** `YYYY-MM`. */
  value: string;
  onChange: (month: string) => void;
}) {
  return (
    <label
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 7,
        alignSelf: 'flex-start',
        fontSize: 'var(--text-meta-lg)',
        color: 'var(--text-muted)',
      }}
    >
      Period
      <input
        type="month"
        value={value}
        onChange={(e) => e.target.value && onChange(e.target.value)}
        aria-label="Period"
        style={{
          borderRadius: 'var(--radius-control)',
          border: '1px solid var(--border-hairline)',
          background: 'var(--surface-card)',
          padding: '5px 7px',
          fontSize: 'var(--text-body-md)',
          color: 'var(--text-strong)',
        }}
      />
    </label>
  );
}
